module.exports = __webpack_public_path__ + "img/AF11X5.png";